import { render, staticRenderFns } from "./CustomerSendEnroll.vue?vue&type=template&id=fd484e28"
import script from "./CustomerSendEnroll.vue?vue&type=script&lang=js"
export * from "./CustomerSendEnroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports